import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createStructuredSelector } from 'reselect';
import { ApplicationRootState } from '../../types';
import { useSelector } from 'react-redux';
import { Furniture } from '../../lib/modelBuilder/entities/Furniture';
import { makeSelectFurniture } from '../Configurator/selectors/furniture';
import CabinetDescription from './CabinetDescription';

// import styled from 'styled-components';

interface StateProps {
  furniture: Furniture | null;
}

const stateSelector = createStructuredSelector<
  ApplicationRootState,
  StateProps
>({
  furniture: makeSelectFurniture(),
});

const Description = () => {
  const { furniture } = useSelector(stateSelector);
  const { t } = useTranslation();

  const [cabinetSelected, setCabinet] = useState(furniture?.cabinets[0]);

  if (furniture) {
    return (
      <div id="description-furniture" className="mt-5 mx-4 ">
        <div className="text-2xl my-2">{t('Data sheet')}</div>

        {furniture &&
          furniture.cabinets.length > 1 &&
          furniture.cabinets.map(cabinetEntry => (
            <button
              onClick={() => {
                setCabinet(cabinetEntry);
              }}
              className={`py-1 px-4 border  ${
                cabinetSelected && cabinetSelected.order === cabinetEntry.order
                  ? 'bg-main  text-white'
                  : 'text-gray-800'
              }`}
            >
              {t('Cabinet')} {cabinetEntry.order + 1}
            </button>
          ))}
        {furniture?.cabinets
          .filter(cabinetEntry => {
            if (!cabinetSelected) return false;
            return cabinetSelected.order === cabinetEntry.order;
          })
          .map(cabinetEntry => (
            <CabinetDescription
              key={cabinetEntry.cabinet.id}
              cabinet={cabinetEntry.cabinet}
            />
          ))}
      </div>
    );
  }
  return null;
};

export default Description;
